import { _ as _type_of } from "@swc/helpers/_/_type_of";
import get from "lodash/get";
var check = function(it) {
    // Math is known to exist as a global in every environment.
    return it && it.Math === Math && it;
};
// IE11 doesn't support globalThis.
var globalObject = check((typeof globalThis === "undefined" ? "undefined" : _type_of(globalThis)) === "object" && globalThis) || // eslint-disable-next-line @faire-web/no-restricted-globals
check("object" === "object" && window) || check((typeof self === "undefined" ? "undefined" : _type_of(self)) === "object" && self) || check((typeof global === "undefined" ? "undefined" : _type_of(global)) === "object" && global) || Function("return this")();
export var defaultLookup = function(prop) {
    return get(globalObject, prop);
};
var lookupOverride;
export var setGlobalLookup = function(lookup) {
    lookupOverride = lookup;
};
export var getGlobalLookup = function() {
    return lookupOverride !== null && lookupOverride !== void 0 ? lookupOverride : defaultLookup;
};
